export const CONTACTED_VICTIM_ID = '1';
export const REFUSED_CONTACT_VICTIM_ID = '3';
export const SECOND_EXAMINATION_VICTIM = 'Victime';
export const SECOND_EXAMINATION_OPPOSING_LAWYER = 'Avocat Adverse';

export const SECOND_EXAMINATION_TYPE = [
  {
    title: SECOND_EXAMINATION_VICTIM,
  },
  {
    title: SECOND_EXAMINATION_OPPOSING_LAWYER,
  },
];
